module.exports = __webpack_public_path__ + "img/15.b94c4004.png";